module.exports = __webpack_public_path__ + "img/img2.d16bfa69.png";